import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import LoginPage from './pages/Login/Login';
import ApplicationMenuInternal from './components/ApplicationMenu/ApplicationMenuInternal';
import SupportRequests from './pages/SupportRequests/SupportRequests';
import ProjectTracker from './pages/ProjectTracker/ProjectTracker';
import VendorMgmt from './pages/VendorMgmt/VendorMgmt';
import NewEstimate from './pages/Estimator/NewEstimate';
import Admin from './pages/Admin/Admin';
import POSummary from './pages/POSummary/POSummary';
import ProcurementRequestPO from './pages/ProcurementRequest/ProcurementRequestPO';
import ProcurementRequestRFQ from './pages/ProcurementRequest/ProcurementRequestRFQ';
import Tutorials from './pages/Tutorials/Tutorials';
import EstimateHistory from './pages/Estimator/EstimateHistory';
import ProjectAnalytics from './pages/ProjectAnalytics/ProjectAnalytics';
import InactivityHandler from './components/Inactivity/InactivityHandler';
import DashboardLayoutBasic from './pages/Dashboard/Dashboard';
import EstimatorApplicationMenuInternal from './pages/Estimator/EstimatorApplicationMenu';
import EditPricing from './pages/Estimator/EditPricing';
import EstimateManagement from './pages/Estimator/EstimateManagement';
import SparrowChat from './pages/Sparrow/SparrowChat';

import './App.css';

const theme = createTheme({
  typography: {
    fontFamily: '"Inter", sans-serif',
    h4: { fontWeight: 100 },
    h6: { fontWeight: 100 },
  },
});

const ProtectedLayout = () => (
  <InactivityHandler>
    <Outlet />
  </InactivityHandler>
);

const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/login" replace /> },
  { path: '/login', element: <LoginPage /> },
  {
    element: <ProtectedLayout />,
    children: [
      {
        element: <DashboardLayoutBasic />,
        children: [
          { path: '/applicationmenu', element: <ApplicationMenuInternal /> },
          { path: '/admin', element: <Admin /> },
          { path: '/projecttracker', element: <ProjectTracker /> },
          { path: '/supportrequests', element: <SupportRequests /> },
          { path: '/vendormgmt', element: <VendorMgmt /> },
          { path: '/estimator-menu', element: <EstimatorApplicationMenuInternal /> },
          { path: '/new-estimate', element: <NewEstimate /> },
          { path: '/estimate-history', element: <EstimateHistory /> },
          { path: '/edit-pipe-pricing', element: <EditPricing /> },
          { path: '/estimate-management', element: <EstimateManagement /> },
          { path: '/projectanalytics', element: <ProjectAnalytics /> },
          { path: '/posummary', element: <POSummary /> },
          { path: '/procurementrequest/po', element: <ProcurementRequestPO /> },
          { path: '/procurementrequest/rfq', element: <ProcurementRequestRFQ /> },
          { path: '/sparrow', element: <SparrowChat /> },
          { path: '/tutorials', element: <Tutorials /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/applicationmenu" replace /> },
]);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
};

export default App;
